import { LayoutModule } from '@angular/cdk/layout';
import { DatePipe, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { enableProdMode, ErrorHandler, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { MissingTranslationHandler, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';

import { CarrouselModule } from '@ecm/carrousel';
import { EcmConsumerModule, ErrorHandlerService } from '@ecm/consumer';
import { EcmDashboardModule } from '@ecm/dashboard';
import { EnvUtils } from '@ecm/dispatcher';
import { ecmEnTranslation } from '@ecm/ecm/lib/i18n/en';
import { ecmFrTranslation } from '@ecm/ecm/lib/i18n/fr';
import { EcmMissingTranslationHandler } from '@ecm/ecm/lib/i18n/missing-translation';
import { DefaultRoutingModule } from '@ecm/ecm/lib/routing/default-routing.module';
import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, RouterReuseStrategy } from '@ecm/router';
import { SmartbannerModule } from '@ecm/smartbanner';
import { EcmTrackerModule } from '@ecm/tracker';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

registerLocaleData(localeFr);

/**
 * 🔥 Modern standalone bootstrap for ecm-app
 * Migrated from AppModule to bootstrapApplication pattern
 */
bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            TranslateModule.forRoot({
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: EcmMissingTranslationHandler,
                },
                defaultLanguage: 'fr',
            }),
            DefaultRoutingModule,
            EcmConsumerModule,
            EcmDashboardModule,
            EcmMaterialModule,
            EcmRouterModule,
            EcmTrackerModule,
            LayoutModule,
            SmartbannerModule,
            CarrouselModule,
            NgxsModule.forRoot([]),
            NgxsReduxDevtoolsPluginModule.forRoot({ disabled: EnvUtils.production }),
        ),
        { provide: LOCALE_ID, useValue: 'fr' },
        DatePipe,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: RouteReuseStrategy, useClass: RouterReuseStrategy },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
    .then((appRef) => {
        // Load translations after bootstrap
        const translateService = appRef.injector.get(TranslateService);
        translateService.setTranslation('en', ecmEnTranslation, true);
        translateService.setTranslation('fr', ecmFrTranslation, true);

        // Some shared router services still call `translateService.use('i18n')`.
        // Ensure this legacy language code has translations so UI labels don't render empty in prod.
        translateService.setTranslation('i18n', ecmFrTranslation, true);
    })
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err));
